import { AtendimentoType, VinculoType } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

/** Filtros da barra. O estado (abas com contagem) fica fora: sempre há um selecionado. */
export type AtendimentosMedicoFilters = {
  paciente: string
  protocolo: string
  empresa?: IOption<number>
  /** Depende da instituição (é limpa quando a instituição sai). */
  unidade?: IOption<number>
  especialidade?: IOption<number>
  retorno?: IOption<boolean>
  tipoAtendimento?: IOption<AtendimentoType>
  vinculo?: IOption<VinculoType>
  /** Período: campo de data ("Consultas entre") + início/fim (aaaa-mm-dd). */
  range?: IOption<string>
  inicio: string
  fim: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<AtendimentosMedicoFilters>(
  {
    paciente: '',
    protocolo: '',
    empresa: undefined,
    unidade: undefined,
    especialidade: undefined,
    retorno: undefined,
    tipoAtendimento: undefined,
    vinculo: undefined,
    range: undefined,
    inicio: '',
    fim: '',
  }
)
